import e from "../managers/braze-instance.js";
import r from "../../shared-lib/braze-shared-lib.js";
export function logFeedDisplayed() {
  if (e.rr()) return e.nr().yr(r.qr.Fr).S;
}
